import { Stack, Typography } from "@mui/material";
import { RichTreeView } from "@mui/x-tree-view/RichTreeView";
import { useTranslation } from "react-i18next";

import { MapEditorFunctionTypeTreeFragment } from "./fragments.generated";

interface MapEditorEcologicalFunctionTypeTreeProps {
    onChange: (values: string[]) => void;
    functionTypes?: MapEditorFunctionTypeTreeFragment[];
    value: string[];
}

export function MapEditorEcologicalFunctionTypeTree({
    onChange,
    functionTypes,
    value,
}: MapEditorEcologicalFunctionTypeTreeProps) {
    const { t } = useTranslation("mapEditor");

    return (
        <Stack direction="column" rowGap={1}>
            <Typography sx={{ paddingInline: 3 / 2 }} variant="overline">
                {t("ecologicalFunctionTypeTree.label")}
            </Typography>

            <RichTreeView
                checkboxSelection
                multiSelect
                items={functionTypes ?? []}
                getItemId={item => item.value}
                getItemLabel={item => `${item.label}`}
                onSelectedItemsChange={(_, nextValues) => onChange(nextValues)}
                selectedItems={value}
            />
        </Stack>
    );
}
